// Activities.jsx
import React from 'react';
import { activities, otherActivities } from '../resources/activities';
import '../scss/Activities.scss';

function Activities() {
    return (
        <div className="paddingStyle">
            <section className='activities-section'>
                <div className='activities-header'>
                    <h1 className='activities-title'>Our Activities</h1>
                    <p className='activities-subtitle'>Making a difference through dedicated service</p>
                </div>

                <div className='activitiesContainer1'>
                    {
                        activities.map(({ title, content, img, loc }, index) => {
                            return (
                                <div key={index} className='activity-card'>
                                    <div className='activities'>
                                        <div className='activitiesContent'>
                                            <div className='activity-header'>
                                                <h2>{title}</h2>
                                                {img !== '' ? (
                                                    <div className='activity-image-wrapper'>
                                                        <img src={img} alt={title} />
                                                    </div>
                                                ) : ''}
                                            </div>
                                            <div className='activity-text'>
                                                <p>{content}</p>
                                                <p className='activity-location'>
                                                    <span className='location-label'>Location:</span> 
                                                    <i>{loc}</i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                    }

                    <div className='otherActivities'>
                        <h2>Other Activities:</h2>
                        <div>
                            <ul >
                                {otherActivities.map((actv, index) => {
                                    return (
                                        <li style={{listStyleType:"none"}} key={index}>{actv}</li>
                                    )
                                })}
                            </ul>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default Activities;